import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Typography
} from '@mui/material';
import i18n from '../../i18';

const AudienceListDialog = ({ open, onClose, onSave, data = null, context, walletNumbers = [] }) => {
    const [formData, setFormData] = useState({
        name: '',
        description: ''
    });

    useEffect(() => {
        if (data) {
            setFormData({
                name: data.name || '',
                description: data.description || ''
            });
        } else {
            // If we have wallet numbers from CSV, suggest a name
            const defaultName = walletNumbers.length > 0 
                ? `Wallet List (${walletNumbers.length} wallets)`
                : '';
            setFormData({
                name: defaultName,
                description: ''
            });
        }
    }, [data, open, walletNumbers]);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSave = () => {
        const saveData = {
            ...formData,
            type: 'ACTIVE', // Set default type as required by server
            walletNumbers: walletNumbers // Include wallet numbers in save data
        };
        
        // If editing existing record, pass ID
        if (data && data.id) {
            saveData.id = data.id;
        }
        
        onSave(saveData);
        onClose();
    };

    const handleCancel = () => {
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                {data ? i18n.t('dialogs.editAudienceList') : i18n.t('dialogs.newAudienceList')}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>{i18n.t('labels.name')}</Typography>
                    <TextField
                        fullWidth
                        placeholder={i18n.t('placeholders.enterListName')}
                        value={formData.name}
                        onChange={(e) => handleInputChange('name', e.target.value)}
                    />
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>{i18n.t('labels.description')}</Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        placeholder={i18n.t('placeholders.enterListDescription')}
                        value={formData.description}
                        onChange={(e) => handleInputChange('description', e.target.value)}
                    />
                </Box>

                {walletNumbers.length > 0 && (
                    <Box sx={{ mb: 3, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                        <Typography variant="subtitle2" gutterBottom color="primary">
                            CSV Import Data
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {walletNumbers.length} wallet numbers imported from CSV file
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            This audience list will be created with the imported wallet numbers
                        </Typography>
                    </Box>
                )}


            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="inherit">
                    {i18n.t('buttons.cancel')}
                </Button>
                <Button onClick={handleSave} variant="contained">
                    {i18n.t('buttons.save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AudienceListDialog; 